import React from 'react';
import { FaBriefcase, FaCode, FaEnvelope, FaGraduationCap, FaHome, FaUser, FaHeadSideVirus  } from 'react-icons/fa';
import { Link } from 'react-scroll';
import './SideNavigation.css';

const SideNavigation = () => {

    return (
        <div className="side-navigation">
            <div className="side-navigation-content">
                <div className="side-nav">
                    <Link to="hero" style={{textDecoration:'none'}}>
                        <div className="navi-icon d-flex justify-content-end">
                            <h3 className="tooltips">HOME</h3>
                            <FaHome className="nav-icon" />
                        </div>
                    </Link>

                    <Link to="about">
                        <div className="navi-icon d-flex justify-content-end">
                            <h3 className="tooltips">ABOUT</h3>
                            <FaUser className="nav-icon" />
                        </div>
                    </Link>

                    <Link to="services">
                        <div className="navi-icon d-flex justify-content-end">
                            <h3 className="tooltips">SERVICES</h3>
                            <FaBriefcase className="nav-icon" />
                        </div>
                    </Link>

                    <Link to="projects">
                        <div className="navi-icon d-flex justify-content-end">
                            <h3 className="tooltips">PROJECTS</h3>
                            <FaCode className="nav-icon" />
                        </div>
                    </Link>
                    <Link to="testimonial">
                        <div className="navi-icon d-flex justify-content-end">
                            <h3 className="tooltips">TESTIMONIALS</h3>
                            <FaGraduationCap className="nav-icon" />
                        </div>
                    </Link>
                    <Link to="contact">
                        <div className="navi-icon d-flex justify-content-end">
                            <h3 className="tooltips">
                                CONTACT</h3>
                            <FaEnvelope className="nav-icon" />
                        </div>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default SideNavigation;